import PropTypes from 'prop-types';
import React from 'react';
import Form from '../../../../components/Form';
import withCollegeService from '../withCollegeService';
import Contact from './contact';

const mapper = {
  namePrefix: 'field_he_xfer_c_name_pref',
  firstName: 'field_he_xfer_c_first_name',
  middleName: 'field_he_xfer_c_middle_name',
  lastName: 'field_he_xfer_c_last_name',
  jobDescription: 'field_he_xfer_c_job_desc',
  country: 'field_he_xfer_c_country_ref',
  state: 'field_he_xfer_c_state_ref',
  city: 'field_he_xfer_c_city',
  zip: 'field_he_xfer_c_post_code',
  street1: 'field_he_xfer_c_addr_line_1',
  street2: 'field_he_xfer_c_addr_line_2',
  email: 'field_he_xfer_c_email',
  fax: 'field_he_xfer_c_fax',
  phoneNumber: 'field_he_xfer_c_phone',
  tollFreeNumber: 'field_he_xfer_c_toll_free_no',
  url: 'field_he_xfer_c_url',
};

const TransferAdmissionsContactComponent = withCollegeService(
  Contact,
  'transferInfo.transferAdmissionsContact',
  {},
  mapper,
  {
    'transferInfo.transferAdmissionsContact.country': 'transferInfo.transferAdmissionsContact.state',
  },
);

const TransferAdmissionsContact = ({ formatMessage }) => (
  <Form>
    <TransferAdmissionsContactComponent formatMessage={formatMessage} />
  </Form>
);
TransferAdmissionsContact.propTypes = {
  formatMessage: PropTypes.func,
};

export default TransferAdmissionsContact;
